var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-box"},_vm._l((_vm.basedata),function(item,i){return _c('div',{key:i,class:item.status == 1?'nav-item-abnormal':'nav-item-normal',on:{"click":function($event){return _vm.check(i)}}},[_vm._v(_vm._s(item.name))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }